import styled from 'styled-components';

export const Textarea = styled.textarea`
  font-size: ${(props) => `2${props.theme.unit}`};
  min-width: ${(props) => `40${props.theme.unit}`};
  min-height: 20vmin;
  padding: ${(props) => `1${props.theme.unit}`};
  border: ${(props) => `0.3${props.theme.unit}`} solid #000;
  border-radius: ${(props) => `0.5${props.theme.unit}`};
  box-shadow: ${(props) => `0 0.4${props.theme.unit} rgba(0, 0, 0, 0.3)`};

  &:invalid:not(:placeholder-shown) {
    border-color: ${(props) => props.theme.color.red};
  }
`;
